/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { SENTINEL_BASE_URL } from "../loader/index.js";
export const baseURL = (config) => {
    if (config.base)
        return config.base;
    if ("window" in globalThis)
        return new URL(self.location.href);
    return SENTINEL_BASE_URL;
};
//# sourceMappingURL=url.js.map